<v-product-details [site]="site" [initCode]="productCode" [isASM]="isAsm" [isAnonymous]="isAnonymous" [isCustomerLoyaltySystem]="isCustomerLoyaltySystem"></v-product-details>
